import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, toJS, Popover2, Fragment} from '@api'
import {BuilderCard, ChangeLogFlexLayoutTabStore, ICatalogItemChangeEvent, useChangeLogFlexLayoutTabStore, useVipLocalStore, VipLocalStore} from '@modules'
import {ChangeLogEntriesForCatalogItemAtTimestamp} from '.'
import {StoresInstance} from '@stores'
import * as css from './ChangeLogEntriesByItemByTimestamp.css'

/// region Store

export class ChangeLogEntriesByItemByTimestampStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'> & { root: ChangeLogFlexLayoutTabStore}) {
    super(stores)
  }

  get root() { return this.props.root}
  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @computed get itemsByCatalogId() {
    const {props: {items}} = this

    return _.groupBy(items, v => v.exId)
  }
}

export const ChangeLogEntriesByItemByTimestampStoreContext = React.createContext<ChangeLogEntriesByItemByTimestampStore>(null)
export const useChangeLogEntriesByItemByTimestampStore = () => React.useContext(ChangeLogEntriesByItemByTimestampStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
  timestamp: number
  items: Array<ICatalogItemChangeEvent>
}

export const ChangeLogEntriesByItemByTimestamp = observer<MyProps>(function ChangeLogEntriesByItemByTimestamp({className, ...props}) {
  const root = useChangeLogFlexLayoutTabStore(),
    obsProps = useAsObservableSource({...props, root}),
    store = useVipLocalStore((stores) => new ChangeLogEntriesByItemByTimestampStore(stores, obsProps)),
    {props: {timestamp, items}, itemsByCatalogId, root: {popoverItem}} = store

  useEffect(() => store.registerEffects(), [])

  // console.log(toJS(itemsByCatalogId))

  return (
    <ChangeLogEntriesByItemByTimestampStoreContext.Provider value={store}>
        {/*<div className={classNames(css.root, className)} data-timestamp={timestamp}>*/}
      <Fragment>
        {_.keys(itemsByCatalogId).map((catalogId, i) =>
          <ChangeLogEntriesForCatalogItemAtTimestamp
            items={itemsByCatalogId[catalogId]}
            catalogId={catalogId}
            index={i}
            key={catalogId} />)}
      </Fragment>
    </ChangeLogEntriesByItemByTimestampStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/changelog/entries/ChangeLogEntriesByItemByTimestamp.tsx